import LiveTimeIcon from './component'

export default LiveTimeIcon